import React from "react"

// Context
import {useUiSkin} from "../../../ui-skin/context/UiSkinContext"

// Components
import HomePage from "../HomePage"
import ModernHomePage from "../modern/ModernHomePage"

/**
 * Chooses the dashboard implementation for the active skin.
 *
 * `any` is correct here: this sits between the route and a page whose props are
 * assembled by `connect`-based HOCs on both branches, so narrowing would only
 * lie. Flipping the skin unmounts one tree and mounts the other, which is
 * intended — no dashboard state is meant to survive the switch.
 *
 * @param props
 */
export default function HomePageSwitch(props: any) {
    const {isModern} = useUiSkin();

    if (isModern) {
        return <ModernHomePage {...props}/>
    }

    return <HomePage {...props}/>
}
